import { render, staticRenderFns } from "./EconomyTableRow.vue?vue&type=template&id=ea68687a&scoped=true&"
import script from "./EconomyTableRow.vue?vue&type=script&lang=js&"
export * from "./EconomyTableRow.vue?vue&type=script&lang=js&"
import style0 from "./EconomyTableRow.vue?vue&type=style&index=0&id=ea68687a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea68687a",
  null
  
)

export default component.exports